'use es6';

import { connect } from 'react-redux';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
const mapStateToProps = state => ({
  requiresExplicitConsentToProcess: getShowGdprConsentToProcess(state)
});
const mapDispatchToProps = {};
export const withConsent = connect(mapStateToProps, mapDispatchToProps);